import { render, staticRenderFns } from "./CheckupsView.vue?vue&type=template&id=32cd7fe3"
import script from "./CheckupsView.vue?vue&type=script&lang=ts"
export * from "./CheckupsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports